export function initRecherchePlaceholder() {
  const recherche = document.querySelector('.parutions-recherche');
  if (!recherche) return;

  const mq = window.matchMedia('(max-width: 377px)');
  const updatePlaceholder = (e) => {
    recherche.placeholder = e.matches
      ? 'Recherche libre'
      : 'Recherche libre dans la collection';
  };
  mq.addEventListener('change', updatePlaceholder);
  updatePlaceholder(mq);
}
